import { useNavigate } from "react-router-dom";
import { Button } from "../../../components/ui/Button";
import { useServiceCarStore } from "../../../store/serviceCarStore";
import { WarningIcon } from "../../../icons/warningIcon";

export const CarImageCard = ({ size = "normal", withDetails=true }) => {
  const navigate = useNavigate();

   const { carInfo } = useServiceCarStore();

  return (
    <div className={`${withDetails ? "flex flex-col items-center gap-2 border border-[#E2E2E2] rounded-[20px] p-6 h-fit min-w-[470px]" : "pl-5 pr-5"}`}>
      {withDetails && <div className="flex justify-between items-center w-full">
        <p className="text-body-large">{carInfo?.MakeName ?? carInfo?.make}</p>
        <Button
          className={
            "rounded-full border border-[#A5A5A5] flex xl:gap-2 py-2 px-5 items-center"
          }
          onClick={() => {
            navigate("/service/notifications_guide");
          }}
        >
          <WarningIcon />
          <p className="text-body">Οδηγός Ενδείξεων</p>
        </Button>
      </div>}
      <img
        className={`${size === "small" ? "w-[420px]" : "extra-small" ? "w-[240px]" : "w-auto"}`}
        alt={`${carInfo?.MakeName ?? carInfo?.make}_${carInfo?.ModelName ?? carInfo?.model}`}
        src={`https://cdn.imagin.studio/getImage?customer=avis-gr&&make=${carInfo?.MakeName ?? carInfo?.make}&modelFamily=${carInfo?.ModelName ?? carInfo?.model}&modelVariant=${carInfo?.ModelName ?? carInfo?.model}&modelYear=${carInfo?.ModelYear}&powerTrain=hybrid&trim=eu&zoomtype=fullscreen&angle=28`}
      />
      {withDetails && <div className="w-full justify-between flex">
        <div>
          <h6>Ημερομηνία Προσφοράς</h6>
          <p className="text-body">
            {carInfo.FirstLicenseDate.split("-")[2] +
              "/" +
              carInfo.FirstLicenseDate.split("-")[1] +
              "/" +
              carInfo.FirstLicenseDate.split("-")[0]}
          </p>
        </div>
        <div>
          <h6>Λήξη Συμβολαίου</h6>
          <p className="text-body">
            {carInfo.EndDate.split("-")[2] +
              "/" +
              carInfo.EndDate.split("-")[1] +
              "/" +
              carInfo.EndDate.split("-")[0]}
          </p>
        </div>
      </div>}
    </div>
  );
};
